<template>
  <v-btn fab small @click="goBack()" :color="color" class="elevation-0 mr-2 ml-n2">
    <v-icon>arrow_back</v-icon>
  </v-btn>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'AppBackButton',
  props: {
    color: {
      type: String,
      default: 'gray'
    }
  },
  computed: {
    ...mapGetters(['previousRoute']),
  },
  methods: {
    ...mapActions(['popRoute']),
    goBack () {
      this.popRoute()
      this.$router.push({ name: this.previousRoute })
    }
  }
}
</script>